package com.milta.core.localization.translations.es

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Suscripción caducada",
    driverSoloMessage = "Tu suscripción ha caducado. Renueva para continuar.",
    patronMessage = "Tu suscripción ha caducado. Tu equipo ya no puede acceder a Milta.",
    driverUnderPatronMessage = "La suscripción de tu organización ha caducado. Contacta con tu organización para restablecer tu acceso.",
    renewButton = "Renovar",
    close = "Cerrar",
    subscribeButtonTemplate = "Suscribirse por %s",
)
